import { appstr } from "./appstr";
import { enumSCDensity } from "../constants";

export function MapDensityToStr(dVal) {
  var dStr = "pagestandard";
  switch (dVal) {
    case enumSCDensity.dense:
      dStr = "pagedense";
      break;
    case enumSCDensity.verydense:
      dStr = "pageverydense";
      break;
  }

  return appstr(dStr);
}
